import React from 'react';
import { Container, Text, Group, Box } from '@mantine/core';
import { Link } from 'react-router-dom';
import classes from './Footer.module.css';

export function Footer() {
  return (
    <footer className={classes.footer}>
      <Container size="xl">
        <div className={classes.inner}>
          <div className={classes.footerTop}>
            <Group>
              <Link to="/terms" className={classes.link}>Terms of Use</Link>
              <Link to="/privacy" className={classes.link}>Privacy Policy</Link>
            </Group>
            <Box className={classes.certificationContainer}>
              <iframe 
                src="https://registry.blockmarktech.com/certificates/6af16f19-2fb9-442f-b42d-9a6f7a9d3e70/widget/?tooltip_position=top_right&theme=transparent&hover=t" 
                style={{ border: 'none', height: '80px', width: '80px' }}
                title="Cyber Essentials Certification"
                aria-label="Cyber Essentials Certified"
              />
            </Box>
          </div>
          <Text size="sm" c="dimmed">
            © {new Date().getFullYear()} Optifyne. All rights reserved.
          </Text>
        </div>
      </Container>
    </footer>
  );
}
